import TravelEssentials from '@v/pages/TravelEssentials.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';

createVueApp(TravelEssentials, { travelEssentials: js_params.travelEssentials }).mount('[data-travel-essentials]');
